export default "__VITE_ASSET__Bkyu5YUp__"